/* =========================================================
   TuchSoft — Software & Plugins index (/software/)
   Progressive enhancement: the cards are already in the DOM
   (grouped in <section class="software-section">); this only
   filters them by free text (data-title / data-search) and by
   family, one chip per section. Loaded only on this page,
   no dependencies, no jQuery.
   ========================================================= */
(function () {
  var toolbar = document.getElementById('softwareToolbar');
  if (!toolbar) return;

  var cards = [].slice.call(document.querySelectorAll('.software-item'));
  if (!cards.length) return;

  var search = document.getElementById('softwareSearch');
  var count = document.getElementById('softwareCount');
  var empty = document.getElementById('softwareEmpty');
  var clear = document.getElementById('softwareClear');
  var tags = document.getElementById('softwareTags');

  var HIDE = 'is-hidden';

  // articles.css scopes `.is-hidden` to `body.page-articles`, so on this page the
  // class alone may not hide anything: fall back to the native [hidden] attribute
  // (the base theme ships `[hidden] { display: none !important; }`). The class is
  // kept so a shared rule keeps working the day it is scoped to this page too.
  var useHiddenAttr = (function () {
    var probe = document.createElement('div');
    probe.className = HIDE;
    document.body.appendChild(probe);
    var hiddenByCss = window.getComputedStyle(probe).display === 'none';
    document.body.removeChild(probe);
    return !hiddenByCss;
  })();

  function show(el, visible) {
    if (!el) return;
    el.classList.toggle(HIDE, !visible);
    if (useHiddenAttr) el.hidden = !visible;
  }

  // one entry per card; the section it sits in is its family
  var sections = [];
  var items = cards.map(function (el) {
    var section = el.closest ? el.closest('.software-section') : null;
    if (section && sections.indexOf(section) === -1) sections.push(section);
    return {
      el: el,
      section: section,
      title: (el.getAttribute('data-title') || '').toLowerCase(),
      search: (el.getAttribute('data-search') || '').toLowerCase()
    };
  });
  var total = items.length;

  var state = { q: '', section: null };

  function apply() {
    var q = state.q.trim().toLowerCase();
    var shown = 0;

    // reset the per-section counters (expando: keeps this ES5 and dependency-free)
    sections.forEach(function (s) { s.__tsVisibleItems = 0; });

    items.forEach(function (item) {
      var ok = true;
      if (state.section && item.section !== state.section) ok = false;
      if (ok && q && item.search.indexOf(q) === -1 && item.title.indexOf(q) === -1) ok = false;

      show(item.el, ok);
      if (ok) {
        shown++;
        if (item.section) item.section.__tsVisibleItems++;
      }
    });

    // a section with no visible card left disappears with them, and comes back
    // as soon as at least one of its cards is visible again
    sections.forEach(function (s) { show(s, s.__tsVisibleItems > 0); });

    if (count) count.textContent = 'Showing ' + shown + ' of ' + total + ' items';
    if (empty) show(empty, shown === 0);
  }

  /* family chips (one per section) --------------------------- */
  var chips = [];

  function makeChip(label, section) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'articles-chip' + (section ? '' : ' is-active');
    btn.setAttribute('data-section', label || 'all');
    btn.textContent = label;
    btn.addEventListener('click', function () { setSection(section); });
    if (tags) tags.appendChild(btn);
    chips.push({ btn: btn, section: section });
    return btn;
  }

  function syncChips() {
    chips.forEach(function (c) {
      c.btn.classList.toggle('is-active', c.section === state.section);
    });
  }

  function setSection(section) {
    // clicking the active chip (or "All") clears the filter
    state.section = (state.section === section) ? null : section;
    syncChips();
    apply();
  }

  if (tags && sections.length > 1) {
    makeChip('All', null);
    sections.forEach(function (s) {
      var title = s.querySelector('.software-section__title');
      var label = title ? title.textContent.trim() : '';
      if (label) makeChip(label, s);
    });
  } else if (tags) {
    show(tags, false);
  }

  /* controls ------------------------------------------------- */
  if (search) {
    var t;
    search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.q = search.value; apply(); }, 150);
    });
  }

  if (clear) {
    clear.addEventListener('click', function () {
      state = { q: '', section: null };
      if (search) search.value = '';
      syncChips();
      apply();
    });
  }

  apply();
})();
